<!--
© Copyright 2015-2026 Personalized Privacy Assistant Project, Carnegie Mellon University - All Rights Reserved - US Patent 11,768,949, US Patent 10,956,586, US Patent 12,235,973, and additional USPTO and EPO patents pending.
This code is proprietary and confidential. For any questions about this code, including licensing, please contact Prof. Norman Sadeh (sadeh@cs.cmu.edu).
-->
<template>

    <!-- My Registries Statistics Panel -->
    <div class="row">
      <!-- My Registries Panel -->
      <div class="col-12">
        <div class="card card-ui-no-border bg-color-light mb-3">
            <h3 class="font-primary font-registry pl-4 pr-4 pt-4">
              <span class="d-none d-md-block smaller float-right">
                CREATE REGISTRY
                <a :href="baseUrls.irrRequestBaseUrl + 'create'"><div class="ml-3 icon-plus-registry icon-small-offset-down"></div></a>
              </span>
              <span class="d-block d-md-none smaller float-right">
                <div class="ml-3 icon-plus-registry icon-small-offset-down shadow-resource"></div>
              </span>
            </h3>
            <div class="row bg-color-light border-rounded-full p-2 m-3">

              <!-- inner cards -->
              <div class="col-lg-4 col-md-8 col-sm-2 pr-1 pl-1">
                <div class="bg-color-light border-dark border-rounded-full p-2 h-100">
                  <div class="row h-100">
                    <div class="col-lg-6 col-md-12">
                      <div class="card card-ui card-ui-no-border card-solid bg-color-light h-100">
                        <div class="card-body d-flex flex-column">
                          <h1>{{irrInfo.total}}</h1>
                          <p>TOTAL REGISTRIES</p>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-6 col-md-12">
                      <div class="card card-ui bg-color-light card-ui-no-border h-100">
                        <table class="table table-sm table-borderless my-auto">
                          <tbody>
                            <!--
                            <tr>
                              <td>
                                <h4 class="color-inherit mb-0">3</h4>
                                <p class="mb-2">DRAFTS</p>
                              </td>
                            </tr>
                            -->
                            <tr>
                              <td>
                                <h4 class="color-inherit mb-0">{{irrInfo.numPending}}</h4>
                                <p class="mb-2">UNDER REVIEW</p>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <h4 class="color-inherit mb-0">{{irrInfo.numApproved}}</h4>
                                <p class="mb-2">APPROVED</p>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-2 col-md-4 col-sm-1 pr-1 pl-1">
                <div class="card card-ui bg-color-light border-dark d-flex h-100">
                  <div v-if="irrInfo.numApproved > 0" class="card-header card-header-success">
                    <div class="icon-registry icon-success icon-offset-down shadow-resource"></div>
                  </div>
                  <div v-else class="card-header card-header-disabled">
                    <div class="icon-registry icon-disabled icon-offset-down shadow-resource"></div>
                  </div>
                  <div class="card-body d-flex flex-column">
                    <h3>{{irrInfo.numApproved}}</h3>
                    <p class="small">APPROVED REGISTRY REQUESTS</p>
                    <a v-if="irrInfo.numApproved > 0" href="./irr-request/" class="btn btn-resource btn-success btn-sm mt-auto">VIEW</a>
                    <button v-else href="#" class="btn btn-resource btn-disabled btn-sm mt-auto" disabled>VIEW</button>
                  </div>
                </div>
              </div>

              <div class="col-lg-2 col-md-4 col-sm-1 pr-1 pl-1">
                <div class="card card-ui bg-color-light border-dark d-flex h-100">
                  <div v-if="irrInfo.numPending > 0" class="card-header card-header-warning">
                    <div class="icon-registry icon-warning icon-offset-down shadow-resource"></div>
                  </div>
                  <div v-else class="card-header card-header-disabled">
                    <div class="icon-registry icon-disabled icon-offset-down shadow-resource"></div>
                  </div>
                  <div class="card-body d-flex flex-column">
                    <h3>{{irrInfo.numPending}}</h3>
                    <p class="small">REGISTRY REQUESTS UNDER REVIEW</p>
                    <a v-if="irrInfo.numPending > 0" href="./irr-request/" class="btn btn-resource btn-warning btn-sm mt-auto">VIEW</a>
                    <button v-else href="#" class="btn btn-resource btn-disabled btn-sm mt-auto" disabled>VIEW</button>
                  </div>
                </div>
              </div>

              <div class="col-lg-2 col-md-4 col-sm-1 pr-1 pl-1">
                <div class="card card-ui bg-color-light border-dark d-flex h-100">
                  <div v-if="irrInfo.numDenied > 0" class="card-header card-header-danger">
                    <div class="icon-registry icon-danger icon-offset-down shadow-resource"></div>
                  </div>
                  <div v-else class="card-header card-header-disabled">
                    <div class="icon-registry icon-disabled icon-offset-down shadow-resource"></div>
                  </div>
                  <div class="card-body d-flex flex-column">
                    <h3>{{irrInfo.numDenied}}</h3>
                    <p class="small">DENIED REGISTRY REQUESTS</p>
                    <a v-if="irrInfo.numDenied > 0" href="./irr-request/" class="btn btn-resource btn-danger btn-sm mt-auto">VIEW</a>
                    <button v-else href="#" class="btn btn-resource btn-disabled btn-sm mt-auto" disabled>VIEW</button>
                  </div>
                </div>
              </div>

              <div class="col-lg-2 col-md-4 col-sm-1 pr-1 pl-1">
                <div class="card card-ui bg-color-light border-dark d-flex h-100">
                  <div v-if="irrInfo.numPendResourcePubReqs > 0" class="card-header card-header-warning">
                    <div class="icon-resource icon-warning icon-offset-down shadow-resource"></div>
                  </div>
                  <div v-else class="card-header card-header-disabled">
                    <div class="icon-resource icon-disabled icon-offset-down shadow-resource"></div>
                  </div>
                  <div class="card-body d-flex flex-column">
                    <h3>{{irrInfo.numPendResourcePubReqs}}</h3>
                    <p class="small">PENDING RESOURCE PUBLICATION REQUESTS</p>
                    <a v-if="irrInfo.numPendResourcePubReqs > 0" href="./irr/index/pendingrequests#list" class="btn btn-resource btn-warning btn-sm mt-auto">VIEW</a>
                    <button v-else href="#" class="btn btn-resource btn-disabled btn-sm mt-auto" disabled>VIEW</button>
                  </div>
                </div>
              </div>

            </div>  <!-- end outer row - my registries -->
        </div>  <!-- end outer card - my registries -->
      </div>  <!-- end outer column - my registries -->
    </div> <!-- end row -->

</template>

<script>
    export default {
      props: {
        irrInfo: Object,
      },
      mounted(){
        //
      },
      data() {
        return {
          baseUrls: {
            resourceBaseUrl: '/resource/',
            irrBaseUrl: '/irr/',
            irrRequestBaseUrl: '/irr-request/',
            templateBaseUrl: '/template/',
            userBaseUrl: '/user/'
          },
        }
      },
      mounted: function () {
        //
      },
    }
</script>
